import Vue from 'vue';
import SvgIcon from '@/components/SvgIcon.vue'

function plugins(Vue) {
  Vue.component('svg-icon',SvgIcon)

}

export default plugins